import styled from 'styled-components';
import { Button } from '~/components';
import { Icon, Typography, getTheme, pxToRem } from '~/modules';

const textBrandAccentLight = getTheme('brand.accent.light');
const spacingSm = getTheme('spacing.sm');
const spacingMd = getTheme('spacing.md');
const spacingLg = getTheme('spacing.lg');

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacingMd}px;
`;

export const PaymentOption = styled(Button)`
  width: 100%;
  margin: auto;
  justify-content: flex-start;
  gap: ${spacingSm}px;
  padding: ${spacingMd}px ${spacingLg}px;
`;

export const PaymentOptionIcon = styled(Icon)`
  font-size: ${pxToRem(20)};
`;

export const PaymentOptionTitle = styled(Typography).attrs({
  variant: 'sm',
})`
  color: ${textBrandAccentLight};
`;

export const ChevronRightIcon = styled(Icon)`
  font-size: ${pxToRem(16)};
  position: absolute;
  right: ${spacingLg}px;
  color: ${textBrandAccentLight};
`;

export const PaymentOptionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;
